<template>
  <svg
    v-if="icon === 'interface-common'"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.6875 10.375C11.7612 10.375 10.945 10.8307 10.4323 11.5236L5.99969 9.25387C6.07328 9.00303 6.125 8.74306 6.125 8.46875C6.125 8.09669 6.04872 7.74297 5.91694 7.41762L10.5558 4.62612C11.0721 5.232 11.8309 5.625 12.6875 5.625C14.2384 5.625 15.5 4.36341 15.5 2.8125C15.5 1.26159 14.2384 0 12.6875 0C11.1366 0 9.875 1.26159 9.875 2.8125C9.875 3.16991 9.94859 3.50894 10.0707 3.82369L5.41797 6.62337C4.90216 6.0355 4.15428 5.65625 3.3125 5.65625C1.76159 5.65625 0.5 6.91784 0.5 8.46875C0.5 10.0197 1.76159 11.2812 3.3125 11.2812C4.25406 11.2812 5.08409 10.8122 5.59484 10.0998L10.0128 12.3622C9.93147 12.6248 9.875 12.8984 9.875 13.1875C9.875 14.7384 11.1366 16 12.6875 16C14.2384 16 15.5 14.7384 15.5 13.1875C15.5 11.6366 14.2384 10.375 12.6875 10.375Z"
      fill="#52525F"
    />
  </svg>
  <svg
    v-else-if="icon === 'interface-common-dialogs'"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="16" height="16" fill="#52525F" />
    <rect x="1" y="2" width="4" height="1" fill="white" />
    <rect x="2" y="8" width="8" height="1" fill="white" />
    <rect x="2" y="10" width="12" height="1" fill="white" />
    <rect x="2" y="12" width="12" height="1" fill="white" />
    <rect
      x="12"
      y="2.98236"
      width="2.80346"
      height="0.467399"
      transform="rotate(-45 12 2.98236)"
      fill="white"
    />
    <rect
      x="12.3305"
      y="1"
      width="2.80346"
      height="0.467399"
      transform="rotate(45 12.3305 1)"
      fill="white"
    />
  </svg>
  <svg
    v-else-if="icon === 'interface-common-breadcrumbs'"
    width="22"
    height="5"
    viewBox="0 0 22 5"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.38486 2.5C5.38486 3.88071 4.17942 5 2.69243 5C1.20544 5 0 3.88071 0 2.5C0 1.11929 1.20544 0 2.69243 0C4.17942 0 5.38486 1.11929 5.38486 2.5Z"
      fill="#52525F"
    />
    <path
      d="M13.6924 2.5C13.6924 3.88071 12.487 5 11 5C9.51301 5 8.30757 3.88071 8.30757 2.5C8.30757 1.11929 9.51301 0 11 0C12.487 0 13.6924 1.11929 13.6924 2.5Z"
      fill="#52525F"
    />
    <path
      d="M22 2.5C22 3.88071 20.7946 5 19.3076 5C17.8206 5 16.6151 3.88071 16.6151 2.5C16.6151 1.11929 17.8206 0 19.3076 0C20.7946 0 22 1.11929 22 2.5Z"
      fill="#52525F"
    />
  </svg>
  <svg
    v-else-if="icon === 'interface-common-pages'"
    width="14"
    height="16"
    viewBox="0 0 14 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M10.2812 1.875H3.71875V0H10.2812V1.875Z" fill="#52525F" />
    <path
      d="M4.1875 9.90625C4.44638 9.90625 4.65625 9.69638 4.65625 9.4375C4.65625 9.17862 4.44638 8.96875 4.1875 8.96875C3.92862 8.96875 3.71875 9.17862 3.71875 9.4375C3.71875 9.69638 3.92862 9.90625 4.1875 9.90625Z"
      fill="#52525F"
    />
    <path
      d="M4.1875 13.6562C4.44638 13.6562 4.65625 13.4464 4.65625 13.1875C4.65625 12.9286 4.44638 12.7188 4.1875 12.7188C3.92862 12.7188 3.71875 12.9286 3.71875 13.1875C3.71875 13.4464 3.92862 13.6562 4.1875 13.6562Z"
      fill="#52525F"
    />
    <path
      d="M4.1875 6.15625C4.44638 6.15625 4.65625 5.94638 4.65625 5.6875C4.65625 5.42862 4.44638 5.21875 4.1875 5.21875C3.92862 5.21875 3.71875 5.42862 3.71875 5.6875C3.71875 5.94638 3.92862 6.15625 4.1875 6.15625Z"
      fill="#52525F"
    />
    <path
      d="M11.2188 0.9375V2.8125H2.78125V0.9375H0.90625V16H13.0938V0.9375H11.2188ZM4.1875 14.5938C3.41206 14.5938 2.78125 13.9629 2.78125 13.1875C2.78125 12.4121 3.41206 11.7812 4.1875 11.7812C4.96294 11.7812 5.59375 12.4121 5.59375 13.1875C5.59375 13.9629 4.96294 14.5938 4.1875 14.5938ZM4.1875 10.8438C3.41206 10.8438 2.78125 10.2129 2.78125 9.4375C2.78125 8.66206 3.41206 8.03125 4.1875 8.03125C4.96294 8.03125 5.59375 8.66206 5.59375 9.4375C5.59375 10.2129 4.96294 10.8438 4.1875 10.8438ZM4.1875 7.09375C3.41206 7.09375 2.78125 6.46294 2.78125 5.6875C2.78125 4.91206 3.41206 4.28125 4.1875 4.28125C4.96294 4.28125 5.59375 4.91206 5.59375 5.6875C5.59375 6.46294 4.96294 7.09375 4.1875 7.09375ZM11.2188 13.6562H6.53125V12.7188H11.2188V13.6562ZM11.2188 9.90625H6.53125V8.96875H11.2188V9.90625ZM11.2188 6.15625H6.53125V5.21875H11.2188V6.15625Z"
      fill="#52525F"
    />
  </svg>
  <svg
    v-else-if="icon === 'interface-common-pages_second'"
    width="12"
    height="16"
    viewBox="0 0 12 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.70312 0H0.609375C0.3505 0 0.140625 0.209875 0.140625 0.46875V1.875H6.70312V0Z"
      fill="#52525F"
    />
    <path
      d="M9.51562 0.46875C9.51562 0.209875 9.30575 0 9.04688 0H7.64062V1.875H9.51562V0.46875Z"
      fill="#52525F"
    />
    <path d="M2.95312 10.5H6.70312V11.4688H2.95312V10.5Z" fill="#52525F" />
    <path
      d="M9.51562 13.1875V2.8125H0.140625V13.1875C0.140625 13.4464 0.3505 13.6562 0.609375 13.6562H9.04688C9.30575 13.6562 9.51562 13.4464 9.51562 13.1875ZM7.64062 11.9375C7.64062 12.1964 7.43075 12.4062 7.17188 12.4062H2.48438C2.2255 12.4062 2.01562 12.1964 2.01562 11.9375V10.0312C2.01562 9.77238 2.2255 9.5625 2.48438 9.5625H7.17188C7.43075 9.5625 7.64062 9.77238 7.64062 10.0312V11.9375ZM7.17188 8.59375H2.48438C2.2255 8.59375 2.01562 8.38387 2.01562 8.125C2.01562 7.86613 2.2255 7.65625 2.48438 7.65625H7.17188C7.43075 7.65625 7.64062 7.86613 7.64062 8.125C7.64062 8.38387 7.43075 8.59375 7.17188 8.59375ZM7.17188 6.71875H2.48438C2.2255 6.71875 2.01562 6.50887 2.01562 6.25C2.01562 5.99113 2.2255 5.78125 2.48438 5.78125H7.17188C7.43075 5.78125 7.64062 5.99113 7.64062 6.25C7.64062 6.50887 7.43075 6.71875 7.17188 6.71875ZM7.17188 4.84375H2.48438C2.2255 4.84375 2.01562 4.63388 2.01562 4.375C2.01562 4.11612 2.2255 3.90625 2.48438 3.90625H7.17188C7.43075 3.90625 7.64062 4.11612 7.64062 4.375C7.64062 4.63388 7.43075 4.84375 7.17188 4.84375Z"
      fill="#52525F"
    />
    <path
      d="M11.3906 1.875H10.4531V3.75H11.8594V2.34375C11.8594 2.08487 11.6495 1.875 11.3906 1.875Z"
      fill="#52525F"
    />
    <path
      d="M10.4531 13.1875C10.4531 13.9629 9.82228 14.5938 9.04688 14.5938H2.01562V15.5312C2.01562 15.7901 2.2255 16 2.48438 16H11.3906C11.6495 16 11.8594 15.7901 11.8594 15.5312V4.6875H10.4531V13.1875Z"
      fill="#52525F"
    />
  </svg>
  <svg
    v-else-if="icon === 'interface-common-add_photo'"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path
        d="M3.33333 6.00003C4.06971 6.00003 4.66666 5.40308 4.66666 4.6667C4.66666 3.93033 4.06971 3.33337 3.33333 3.33337C2.59695 3.33337 2 3.93033 2 4.6667C2 5.40308 2.59695 6.00003 3.33333 6.00003Z"
        fill="#52525F"
      />
      <path
        d="M6.33333 11.6667C6.33333 9.068 8.20267 6.90067 10.6667 6.43067V2C10.6667 0.897333 9.76933 0 8.66667 0H2C0.897333 0 0 0.897333 0 2V11.3333C0 12.436 0.897333 13.3333 2 13.3333H6.604C6.43067 12.808 6.33333 12.2493 6.33333 11.6667V11.6667ZM3.16 8.12C2.72 7.68 1.94667 7.68 1.50667 8.12L1.33333 8.29267V2C1.33333 1.632 1.632 1.33333 2 1.33333H8.66667C9.03467 1.33333 9.33333 1.632 9.33333 2V6.29267L8.82667 5.786C8.37067 5.33 7.62867 5.33 7.17333 5.786L4 8.95933L3.16 8.12Z"
        fill="#52525F"
      />
      <path
        d="M11.6663 7.33337C9.277 7.33337 7.33301 9.27737 7.33301 11.6667C7.33301 14.056 9.277 16 11.6663 16C14.0557 16 15.9996 14.056 15.9996 11.6667C15.9996 9.27737 14.0557 7.33337 11.6663 7.33337ZM13.4997 12.3334H12.333V13.5C12.333 13.8687 12.035 14.1667 11.6663 14.1667C11.2977 14.1667 10.9997 13.8687 10.9997 13.5V12.3334H9.833C9.46433 12.3334 9.16633 12.0354 9.16633 11.6667C9.16633 11.298 9.46433 11 9.833 11H10.9997V9.83337C10.9997 9.46471 11.2977 9.16671 11.6663 9.16671C12.035 9.16671 12.333 9.46471 12.333 9.83337V11H13.4997C13.8683 11 14.1663 11.298 14.1663 11.6667C14.1663 12.0354 13.8683 12.3334 13.4997 12.3334Z"
        fill="#52525F"
      />
    </g>
  </svg>
  <svg
    v-else-if="icon === 'interface-common-adress'"
    width="12"
    height="15"
    viewBox="0 0 12 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6 0.666626C7.5913 0.666626 9.11742 1.29877 10.2426 2.42399C11.3679 3.5492 12 5.07533 12 6.66663C12 9.15063 10.1067 11.7533 6.4 14.5333C6.2846 14.6198 6.14425 14.6666 6 14.6666C5.85575 14.6666 5.7154 14.6198 5.6 14.5333C1.89333 11.7533 0 9.15063 0 6.66663C0 5.07533 0.632141 3.5492 1.75736 2.42399C2.88258 1.29877 4.4087 0.666626 6 0.666626V0.666626ZM6 4.66663C5.46957 4.66663 4.96086 4.87734 4.58579 5.25241C4.21071 5.62749 4 6.13619 4 6.66663C4 7.19706 4.21071 7.70577 4.58579 8.08084C4.96086 8.45591 5.46957 8.66663 6 8.66663C6.53043 8.66663 7.03914 8.45591 7.41421 8.08084C7.78929 7.70577 8 7.19706 8 6.66663C8 6.13619 7.78929 5.62749 7.41421 5.25241C7.03914 4.87734 6.53043 4.66663 6 4.66663Z"
      fill="#52525F"
    />
  </svg>
  <svg
    v-else-if="icon === 'interface-common-adress_check'"
    width="14"
    height="16"
    viewBox="0 0 14 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.6919 0.411067C12.4487 0.299006 12.1621 0.342613 11.9631 0.52188L10.9134 1.45131C10.8849 1.47673 10.8418 1.47657 10.8134 1.45101L9.38517 0.173594C9.12686 -0.0578648 8.7358 -0.0578648 8.47749 0.173594L7.05053 1.44984C7.02183 1.47548 6.97845 1.47548 6.94974 1.44984L5.52264 0.173594C5.26433 -0.057827 4.87327 -0.057827 4.61495 0.173594L3.18653 1.45101C3.15793 1.47657 3.11474 1.47669 3.086 1.45127L2.03536 0.52188C1.75662 0.274007 1.32971 0.299006 1.08184 0.57774C0.970682 0.702736 0.909867 0.864531 0.911153 1.03177V14.9683C0.908657 15.3419 1.20948 15.6467 1.58307 15.6492C1.75042 15.6504 1.91221 15.5894 2.03725 15.4782L3.08695 14.5487C3.1155 14.5233 3.15858 14.5235 3.18698 14.549L4.61522 15.8264C4.87353 16.0579 5.26459 16.0579 5.5229 15.8264L6.95001 14.5502C6.97871 14.5246 7.02209 14.5246 7.0508 14.5502L8.4779 15.8264C8.73625 16.0578 9.12728 16.0578 9.38559 15.8264L10.8141 14.549C10.8427 14.5234 10.8859 14.5233 10.9146 14.5487L11.9653 15.4781C12.2441 15.7259 12.671 15.7007 12.9187 15.4218C13.0297 15.297 13.0904 15.1354 13.0892 14.9683V1.03177C13.0928 0.764043 12.9365 0.519914 12.6919 0.411067ZM3.41511 5.42825H7.18147C7.34856 5.42825 7.48403 5.56372 7.48403 5.73081C7.48403 5.8979 7.34856 6.03337 7.18147 6.03337H3.41511C3.24802 6.03337 3.11255 5.8979 3.11255 5.73081C3.11255 5.56372 3.24802 5.42825 3.41511 5.42825ZM10.5853 10.5718H3.41511C3.24802 10.5718 3.11255 10.4363 3.11255 10.2692C3.11255 10.1021 3.24802 9.96667 3.41511 9.96667H10.5853C10.7524 9.96667 10.8878 10.1021 10.8878 10.2692C10.8878 10.4363 10.7524 10.5718 10.5853 10.5718ZM10.5853 8.30258H3.41511C3.24802 8.30258 3.11255 8.16711 3.11255 8.00002C3.11255 7.83293 3.24802 7.69746 3.41511 7.69746H10.5853C10.7524 7.69746 10.8878 7.83293 10.8878 8.00002C10.8878 8.16711 10.7524 8.30258 10.5853 8.30258Z"
      fill="#52525F"
    />
  </svg>
  <svg
    v-else-if="icon === 'interface-common-buttons'"
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="16" height="7" rx="3.5" fill="#52525F" />
    <path
      d="M7.50009 4C6.30009 4 6.16675 6.66667 6.50008 8C7.83342 9.16667 9.90009 10.8 9.50009 8C9.00009 4.5 8.70009 4 7.50009 4Z"
      fill="white"
    />
    <path
      d="M13.601 15.6333L9.55843 16.3218C9.39939 16.0004 9.1464 15.7644 8.64522 15.3949C8.03004 15.096 7.50971 14.5763 6.913 13.9755C6.31629 13.3747 4.58017 12.8248 4.08627 12.7391C3.59238 12.6534 3.59215 12.1335 4.02377 11.666C4.45538 11.1985 5.29769 11.4915 5.80547 11.6927C6.31325 11.8938 7.00335 12.217 7.28423 11.8363C7.66267 11.3233 7.24438 8.06997 6.98793 6.5074C6.86054 5.82985 6.80035 4.46105 7.57866 4.40625C8.55154 4.33777 8.61387 8.21345 8.6636 8.44809C8.70338 8.63581 8.78201 8.63439 8.81636 8.61021C8.89946 8.41368 9.12624 7.99724 9.36859 7.90369C9.67153 7.78674 10.0067 8.33085 10.314 8.38417C10.4999 7.9644 10.7303 7.74446 11.0376 7.79779C11.3449 7.85112 11.6939 8.2507 11.9368 8.34936C12.3611 7.98904 12.5824 8.01689 12.64 8.07586C13.6404 8.56587 13.8868 10.0777 14.1387 11.0368C14.3905 11.9959 13.9618 14.5319 13.721 14.9422C13.5284 15.2704 13.5608 15.5397 13.601 15.6333Z"
      fill="#52525F"
    />
  </svg>
  <svg
    v-else-if="icon === 'interface-common-charts'"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 8.4C0 2 5.46098 0.6 7.44679 0.5V8.4C9.69738 8.73333 14.4766 9.44 15.5886 9.6C13.7021 15.7 9.53189 16 7.44679 16C5.36169 16 0.0992905 14.5 0 8.4Z"
      fill="#52525F"
    />
    <path
      d="M15.9858 8.4C16.3035 2.16 11.2198 0.2 8.63829 0V7.4C10.2931 7.66667 14.0794 8.24 15.9858 8.4Z"
      fill="#52525F"
    />
  </svg>
  <svg
    v-else-if="icon === 'interface-common-checkbox'"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.98444 12.5315C2.97919 12.5316 2.974 12.5317 2.96881 12.5317C2.84472 12.5317 2.72541 12.4825 2.63738 12.3945L2.01231 11.7694C1.82925 11.5864 1.82925 11.2896 2.01231 11.1065C2.19534 10.9235 2.49216 10.9235 2.67522 11.1065L2.94597 11.3772L4.94338 9.09424H0.46875C0.209875 9.09424 0 9.30411 0 9.56299V13.938C0 14.1969 0.209875 14.4067 0.46875 14.4067H5.15641C5.41528 14.4067 5.62516 14.1969 5.62516 13.938V9.73868L3.32159 12.3716C3.23619 12.4693 3.11406 12.5271 2.98444 12.5315V12.5315Z"
      fill="#52525F"
    />
    <path
      d="M15.5309 8.46899H8.90635C8.7496 8.46899 8.60326 8.54734 8.51635 8.67774L6.64123 11.4905C6.53626 11.648 6.53626 11.8531 6.64123 12.0106L8.51635 14.8233C8.60326 14.9537 8.74963 15.0321 8.90635 15.0321H15.5309C15.7898 15.0321 15.9997 14.8222 15.9997 14.5633V8.93774C15.9997 8.67884 15.7898 8.46899 15.5309 8.46899V8.46899ZM13.6558 13.1568H10.1565C9.8976 13.1568 9.68773 12.947 9.68773 12.6881C9.68773 12.4292 9.8976 12.2193 10.1565 12.2193H13.6558C13.9147 12.2193 14.1245 12.4292 14.1245 12.6881C14.1245 12.947 13.9146 13.1568 13.6558 13.1568V13.1568ZM13.6558 11.2817H10.7815C10.5226 11.2817 10.3128 11.0718 10.3128 10.8129C10.3128 10.554 10.5226 10.3442 10.7815 10.3442H13.6558C13.9146 10.3442 14.1245 10.554 14.1245 10.8129C14.1245 11.0718 13.9146 11.2817 13.6558 11.2817Z"
      fill="#52525F"
    />
    <path
      d="M2.98425 5.0306C2.97909 5.03076 2.97394 5.03085 2.96881 5.03085C2.84472 5.03085 2.72541 4.9816 2.63738 4.89357L2.01231 4.26851C1.82925 4.08548 1.82925 3.78866 2.01231 3.6056C2.19534 3.42257 2.49216 3.42257 2.67522 3.6056L2.94625 3.87663L4.94719 1.59338H0.46875C0.209875 1.59338 0 1.80326 0 2.06213V6.43713C0 6.69601 0.209875 6.90588 0.46875 6.90588H5.15641C5.41528 6.90588 5.62516 6.69601 5.62516 6.43713V2.2421L3.32134 4.87101C3.23587 4.96857 3.11384 5.02632 2.98425 5.0306Z"
      fill="#52525F"
    />
    <path
      d="M15.5309 0.96814H8.90635C8.7496 0.96814 8.60326 1.04648 8.51635 1.17689L6.64123 3.9897C6.53626 4.14711 6.53626 4.35226 6.64123 4.5097L8.51635 7.32248C8.60326 7.45289 8.74963 7.53123 8.90635 7.53123H15.5309C15.7898 7.53123 15.9997 7.32136 15.9997 7.06248V1.43689C15.9997 1.17801 15.7898 0.96814 15.5309 0.96814V0.96814ZM13.6558 5.65601H10.1565C9.8976 5.65601 9.68773 5.44614 9.68773 5.18726C9.68773 4.92839 9.8976 4.71851 10.1565 4.71851H13.6558C13.9147 4.71851 14.1245 4.92839 14.1245 5.18726C14.1245 5.44614 13.9146 5.65601 13.6558 5.65601V5.65601ZM13.6558 3.78083H10.7815C10.5226 3.78083 10.3128 3.57095 10.3128 3.31208C10.3128 3.0532 10.5226 2.84333 10.7815 2.84333H13.6558C13.9146 2.84333 14.1245 3.0532 14.1245 3.31208C14.1245 3.57095 13.9146 3.78083 13.6558 3.78083Z"
      fill="#52525F"
    />
  </svg>
  <svg
    v-else-if="icon === 'interface-common-contacts'"
    width="14"
    height="16"
    viewBox="0 0 14 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13 2H11.5V0.5C11.5 0.224 11.276 0 11 0H2C1.173 0 0.5 0.673 0.5 1.5V14C0.5 15.103 1.397 16 2.5 16H13C13.276 16 13.5 15.776 13.5 15.5V2.5C13.5 2.224 13.276 2 13 2ZM10.5 12.5C10.5 12.776 10.276 13 10 13H4C3.724 13 3.5 12.776 3.5 12.5V11.5C3.5 10.121 4.622 9 6 9H8C9.379 9 10.5 10.121 10.5 11.5V12.5ZM5 6C5 4.897 5.897 4 7 4C8.103 4 9 4.897 9 6C9 7.103 8.103 8 7 8C5.897 8 5 7.103 5 6ZM10.5 2H2C1.724 2 1.5 1.776 1.5 1.5C1.5 1.224 1.724 1 2 1H10.5V2Z"
      fill="#52525F"
    />
  </svg>
  <svg
    v-else-if="icon === 'interface-common-add_edit'"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path
        d="M12.6667 8.00002C12.298 8.00002 12 8.29869 12 8.66669V14C12 14.3674 11.7013 14.6667 11.3333 14.6667H2C1.632 14.6667 1.33333 14.3674 1.33333 14V4.66669C1.33333 4.29935 1.632 4.00002 2 4.00002H7.33333C7.702 4.00002 8 3.70135 8 3.33335C8 2.96535 7.702 2.66669 7.33333 2.66669H2C0.897333 2.66669 0 3.56402 0 4.66669V14C0 15.1027 0.897333 16 2 16H11.3333C12.436 16 13.3333 15.1027 13.3333 14V8.66669C13.3333 8.29802 13.0353 8.00002 12.6667 8.00002Z"
        fill="#52525F"
      />
      <path
        d="M6.25081 7.39265C6.20414 7.43931 6.17281 7.49865 6.15948 7.56265L5.68814 9.91998C5.66614 10.0293 5.70081 10.142 5.77948 10.2213C5.84281 10.2846 5.92814 10.3186 6.01548 10.3186C6.03681 10.3186 6.05881 10.3166 6.08081 10.312L8.43748 9.84065C8.50281 9.82731 8.56214 9.79598 8.60814 9.74931L13.8828 4.47465L11.5261 2.11798L6.25081 7.39265Z"
        fill="#52525F"
      />
      <path
        d="M15.512 0.487988C14.862 -0.162012 13.8047 -0.162012 13.1553 0.487988L12.2327 1.41065L14.5893 3.76732L15.512 2.84465C15.8267 2.53065 16 2.11199 16 1.66665C16 1.22132 15.8267 0.802655 15.512 0.487988Z"
        fill="#52525F"
      />
    </g>
  </svg>
  <svg
    v-else-if="icon === 'interface-common-delete'"
    width="10"
    height="10"
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.67695 8.11723L6.55863 4.99997L9.67695 1.88277C9.88379 1.67594 10 1.39541 10 1.10291C10 0.810402 9.88379 0.529878 9.67695 0.323045C9.47012 0.116213 9.1896 0 8.89709 0C8.60459 0 8.32406 0.116213 8.11723 0.323045L4.99997 3.44137L1.88277 0.323045C1.67594 0.116213 1.39541 0 1.10291 0C0.958073 0 0.81466 0.0285035 0.680851 0.083929C0.547042 0.139355 0.425458 0.220632 0.323045 0.323045C0.220632 0.425458 0.139355 0.547042 0.083929 0.680851C0.0285035 0.81466 0 0.958073 0 1.10291C0 1.39541 0.116213 1.67594 0.323045 1.88277L3.44137 4.99997L0.323045 8.11723C0.220632 8.21964 0.139355 8.34123 0.083929 8.47504C0.0285035 8.60885 0 8.75226 0 8.89709C0 9.1896 0.116213 9.47012 0.323045 9.67695C0.529878 9.88379 0.810402 10 1.10291 10C1.39541 10 1.67594 9.88379 1.88277 9.67695L4.99997 6.55863L8.11723 9.67695C8.32406 9.88379 8.60459 10 8.89709 10C9.1896 10 9.47012 9.88379 9.67695 9.67695C9.88379 9.47012 10 9.1896 10 8.89709C10 8.60459 9.88379 8.32406 9.67695 8.11723Z"
      fill="#2C2C2C"
    />
  </svg>
  <svg
    v-else-if="icon === 'interface-common-edit'"
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 19.2806V23.3334C0 23.7067 0.293294 24 0.666576 24H4.71936C4.89267 24 5.06598 23.9333 5.18596 23.8L19.744 9.25534L14.7447 4.25601L0.199973 18.8007C0.0666577 18.934 0 19.094 0 19.2806ZM23.6101 5.38919C23.7337 5.26586 23.8318 5.11936 23.8987 4.95809C23.9656 4.79681 24 4.62392 24 4.44932C24 4.27472 23.9656 4.10183 23.8987 3.94056C23.8318 3.77928 23.7337 3.63278 23.6101 3.50945L20.4906 0.389872C20.3672 0.266284 20.2207 0.168234 20.0594 0.101335C19.8982 0.0344353 19.7253 0 19.5507 0C19.3761 0 19.2032 0.0344353 19.0419 0.101335C18.8806 0.168234 18.7341 0.266284 18.6108 0.389872L16.1711 2.82954L21.1705 7.82886L23.6101 5.38919Z"
      fill="#52525F"
    />
  </svg>
  <svg
    v-else-if="icon === 'interface-common-inputs'"
    width="23"
    height="10"
    viewBox="0 0 23 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="23" height="10" rx="3" fill="#52525F" />
    <rect x="2.30005" y="4" width="9.2" height="2" fill="white" />
  </svg>
  <svg
    v-else-if="icon === 'interface-common-inputs_error'"
    width="27"
    height="14"
    viewBox="0 0 27 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="23" height="10" rx="3" fill="#52525F" />
    <path
      d="M26.4713 10.3493L22.9527 4.63333C22.7227 4.24267 22.2933 4 21.8333 4C21.3733 4 20.944 4.24267 20.7207 4.62267L17.21 10.3267C17.0727 10.5307 17 10.774 17 11.03C17 11.7487 17.5867 12.3333 18.308 12.3333H25.3587C26.08 12.3333 26.6667 11.7487 26.6667 11.03C26.6667 10.774 26.594 10.5307 26.4713 10.3493Z"
      fill="white"
    />
    <path
      d="M26.4713 11.3493L22.9527 5.63333C22.7227 5.24267 22.2933 5 21.8333 5C21.3733 5 20.944 5.24267 20.7207 5.62267L17.21 11.3267C17.0727 11.5307 17 11.774 17 12.03C17 12.7487 17.5867 13.3333 18.308 13.3333H25.3587C26.08 13.3333 26.6667 12.7487 26.6667 12.03C26.6667 11.774 26.594 11.5307 26.4713 11.3493ZM21.8333 12C21.4653 12 21.1667 11.7013 21.1667 11.3333C21.1667 10.9653 21.4653 10.6667 21.8333 10.6667C22.2013 10.6667 22.5 10.9653 22.5 11.3333C22.5 11.7013 22.2013 12 21.8333 12ZM22.5 9.66667C22.5 10.0347 22.202 10.3333 21.8333 10.3333C21.4647 10.3333 21.1667 10.0347 21.1667 9.66667V8.33333C21.1667 7.96533 21.4647 7.66667 21.8333 7.66667C22.202 7.66667 22.5 7.96533 22.5 8.33333V9.66667Z"
      fill="#52525F"
    />
    <rect x="2.2998" y="4" width="9.2" height="2" fill="white" />
  </svg>
  <svg
    v-else-if="icon === 'interface-common-labels'"
    width="23"
    height="14"
    viewBox="0 0 23 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect y="5" width="23" height="9" rx="3" fill="#52525F" />
    <rect x="1.5332" width="9.2" height="2" fill="#52525F" />
  </svg>
  <svg
    v-else-if="icon === 'interface-common-notifications'"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.32336 16C8.53076 16 9.54077 15.1393 9.77271 14H4.87402C5.10608 15.1393 6.11609 16 7.32336 16Z"
      fill="#52525F"
    />
    <path
      d="M11.998 7.99939C11.9953 7.99939 11.9926 8 11.9899 8C9.41728 8 7.32329 5.90662 7.32329 3.33337C7.32329 2.62598 7.48601 1.95728 7.76934 1.35596C7.62261 1.34204 7.47393 1.33337 7.32329 1.33337C4.74602 1.33337 2.65667 3.42261 2.65667 6V7.85864C2.65667 9.17798 2.07866 10.4233 1.06462 11.2806C0.726611 11.5693 0.576587 12.0293 0.697925 12.478C0.839282 13 1.35527 13.3334 1.89666 13.3334H12.7466C13.3146 13.3334 13.85 12.9653 13.9653 12.4087C14.0546 11.978 13.9013 11.548 13.5673 11.2673C12.5979 10.4547 12.0373 9.26062 11.998 7.99939Z"
      fill="#52525F"
    />
    <path
      d="M15.3234 3.33337C15.3234 5.17432 13.8311 6.66663 11.99 6.66663C10.149 6.66663 8.65674 5.17432 8.65674 3.33337C8.65674 1.49243 10.149 0 11.99 0C13.8311 0 15.3234 1.49243 15.3234 3.33337Z"
      fill="#52525F"
    />
  </svg>
  <svg
    v-else-if="icon === 'interface-common-offices'"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.94922 10.9803V16H11.0433C11.0433 15.1167 11.0433 11.465 11.0433 10.9803C9.46332 10.9803 4.53927 10.9803 2.94922 10.9803ZM5.23941 14.0235H4.23549V13.0823H5.23941V14.0235ZM9.75706 14.0235H8.75314V13.0823H9.75706V14.0235ZM7.49824 14.0235H6.49432V13.0823H7.49824V14.0235Z"
      fill="#52525F"
    />
    <path
      d="M8.28223 6.22272V10.0392H11.9842V16H13.992C13.992 15.1384 13.992 3.2998 13.992 2.91699C12.022 4.05751 11.5337 4.34011 8.28223 6.22272V6.22272ZM10.2587 8.47056V7.52938H12.0156V8.47056H10.2587Z"
      fill="#52525F"
    />
    <path
      d="M9.53726 0V2.5098H6.46275V0H0V16H2.00784C2.00784 15.7368 2.00784 10.3448 2.00784 10.0392H6.46275V3.45098H9.53726V4.40878C13.6762 2.01377 4.09995 7.55661 14.9333 1.28471V16H16V0H9.53726ZM4.48627 8.97255H1.97647V8.03137H4.48627V8.97255ZM4.48627 6.96471H1.97647V6.02353H4.48627V6.96471ZM4.48627 4.95686H1.97647V4.01569H4.48627V4.95686ZM4.48627 2.94902H1.97647V2.00784H4.48627V2.94902Z"
      fill="#52525F"
    />
  </svg>
  <svg
    v-else-if="icon === 'interface-common-pagination'"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.8135 12.2184L10.9306 11.3349L14.2374 8.03039L10.9286 4.69165L11.8155 3.8125L16 8.03466L11.8135 12.2184ZM5.06933 11.3349L1.76257 8.03039L5.07152 4.69165L4.18444 3.8125L0 8.03466L4.18652 12.2184L5.06933 11.3349ZM8.62449 8.03002C8.62449 8.37426 8.34434 8.65441 7.99998 8.65441C7.65562 8.65441 7.3756 8.37426 7.3756 8.03002C7.3756 7.68566 7.65562 7.40551 7.99998 7.40551C8.34434 7.40551 8.62449 7.68566 8.62449 8.03002ZM11.1223 8.03002C11.1223 8.37426 10.8421 8.65441 10.4978 8.65441C10.1534 8.65441 9.87339 8.37426 9.87339 8.03002C9.87339 7.68566 10.1534 7.40551 10.4978 7.40551C10.8421 7.40551 11.1223 7.68566 11.1223 8.03002ZM6.1267 8.03002C6.1267 8.37426 5.84655 8.65441 5.50219 8.65441C5.15783 8.65441 4.8778 8.37426 4.8778 8.03002C4.8778 7.68566 5.15783 7.40551 5.50219 7.40551C5.84655 7.40551 6.1267 7.68566 6.1267 8.03002Z"
      fill="#52525F"
    />
  </svg>
  <svg
    v-else-if="icon === 'interface-common-reports'"
    width="12"
    height="16"
    viewBox="0 0 12 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 5C7.449 5 7 4.551 7 4V0H1C0.449 0 0 0.449 0 1V15C0 15.552 0.449 16 1 16H11C11.552 16 12 15.552 12 15V5H8ZM4 14H2V11H4V14ZM7 14H5V9H7V14ZM10 14H8V7H10V14Z"
      fill="#52525F"
    />
  </svg>
  <svg
    v-else-if="icon === 'interface-common-sections'"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path
        d="M15.3334 8.66669H9.33341C8.96541 8.66669 8.66675 8.96535 8.66675 9.33335V15.3333C8.66675 15.7013 8.96541 16 9.33341 16H15.3334C15.7014 16 16.0001 15.7013 16.0001 15.3333V9.33335C16.0001 8.96535 15.7014 8.66669 15.3334 8.66669Z"
        fill="#52525F"
      />
      <path
        d="M15.3334 0H9.33341C8.96541 0 8.66675 0.298667 8.66675 0.666667V6.66667C8.66675 7.03467 8.96541 7.33333 9.33341 7.33333H15.3334C15.7014 7.33333 16.0001 7.03467 16.0001 6.66667V0.666667C16.0001 0.298667 15.7014 0 15.3334 0Z"
        fill="#52525F"
      />
      <path
        d="M0.666667 16H6.66667C7.03467 16 7.33333 15.7013 7.33333 15.3333V0.666667C7.33333 0.298667 7.03467 0 6.66667 0H0.666667C0.298667 0 0 0.298667 0 0.666667V15.3333C0 15.7013 0.298667 16 0.666667 16Z"
        fill="#52525F"
      />
    </g>
  </svg>
  <svg
    v-else-if="icon === 'interface-common-status'"
    width="22"
    height="11"
    viewBox="0 0 22 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="22" height="11" rx="5.5" fill="#52525F" />
    <path d="M6 3H7V8H6V3Z" fill="white" />
    <path d="M9 5V6L4 6L4 5L9 5Z" fill="white" />
    <rect x="18" y="5" width="1" height="5" transform="rotate(90 18 5)" fill="white" />
  </svg>
  <svg
    v-else-if="icon === 'interface-common-tables'"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14 1H2C1.73478 1 1.48043 1.10536 1.29289 1.29289C1.10536 1.48043 1 1.73478 1 2V14C1 14.2652 1.10536 14.5196 1.29289 14.7071C1.48043 14.8946 1.73478 15 2 15H14C14.2652 15 14.5196 14.8946 14.7071 14.7071C14.8946 14.5196 15 14.2652 15 14V2C15 1.73478 14.8946 1.48043 14.7071 1.29289C14.5196 1.10536 14.2652 1 14 1ZM2 0C1.46957 0 0.960859 0.210714 0.585786 0.585786C0.210714 0.960859 0 1.46957 0 2V14C0 14.5304 0.210714 15.0391 0.585786 15.4142C0.960859 15.7893 1.46957 16 2 16H14C14.5304 16 15.0391 15.7893 15.4142 15.4142C15.7893 15.0391 16 14.5304 16 14V2C16 1.46957 15.7893 0.960859 15.4142 0.585786C15.0391 0.210714 14.5304 0 14 0H2Z"
      fill="#52525F"
    />
    <path fill-rule="evenodd" clip-rule="evenodd" d="M15 4H1V3H15V4Z" fill="#52525F" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5 15.5V1.5H6V15.5H5ZM10 15.5V1.5H11V15.5H10Z"
      fill="#52525F"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15 8H1V7H15V8ZM15 12H1V11H15V12Z"
      fill="#52525F"
    />
    <path
      d="M0 2C0 1.46957 0.210714 0.960859 0.585786 0.585786C0.960859 0.210714 1.46957 0 2 0H14C14.5304 0 15.0391 0.210714 15.4142 0.585786C15.7893 0.960859 16 1.46957 16 2V4H0V2Z"
      fill="#52525F"
    />
  </svg>
  <svg
    v-else-if="icon === 'interface-common-text'"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.46875 3.56984C0.727625 3.56984 0.9375 3.35997 0.9375 3.10109V0.9375H3.10109C3.35997 0.9375 3.56984 0.727625 3.56984 0.46875C3.56984 0.209875 3.35997 0 3.10109 0H0.46875C0.209875 0 0 0.209875 0 0.46875V3.10109C0 3.36 0.209875 3.56984 0.46875 3.56984Z"
      fill="#52525F"
    />
    <path
      d="M15.5308 0H12.8984C12.6396 0 12.4297 0.209875 12.4297 0.46875C12.4297 0.727625 12.6396 0.9375 12.8984 0.9375H15.062V3.10109C15.062 3.35997 15.2719 3.56984 15.5308 3.56984C15.7897 3.56984 15.9995 3.35997 15.9995 3.10109V0.46875C15.9995 0.209875 15.7897 0 15.5308 0Z"
      fill="#52525F"
    />
    <path
      d="M15.5308 12.4302C15.2719 12.4302 15.062 12.6401 15.062 12.8989V15.0625H12.8984C12.6396 15.0625 12.4297 15.2724 12.4297 15.5313C12.4297 15.7901 12.6396 16 12.8984 16H15.5308C15.7897 16 15.9995 15.7901 15.9995 15.5313V12.8989C15.9995 12.64 15.7897 12.4302 15.5308 12.4302Z"
      fill="#52525F"
    />
    <path
      d="M3.10109 15.0625H0.9375V12.8989C0.9375 12.6401 0.727625 12.4302 0.46875 12.4302C0.209875 12.4302 0 12.6401 0 12.8989V15.5313C0 15.7901 0.209875 16 0.46875 16H3.10109C3.35997 16 3.56984 15.7901 3.56984 15.5313C3.56984 15.2724 3.36 15.0625 3.10109 15.0625Z"
      fill="#52525F"
    />
    <path
      d="M13.1145 5.98064V3.02033C13.1145 2.87346 12.9954 2.75439 12.8482 2.75439H8.00012H3.15199C3.0048 2.75439 2.88574 2.87346 2.88574 3.02033V5.98064C2.88574 6.12783 3.0048 6.24689 3.15199 6.24689H4.56574C4.71262 6.24689 4.83168 6.12783 4.83168 5.98064V4.96658C4.83168 4.81939 4.95105 4.70033 5.09793 4.70033H6.76074C6.90793 4.70033 7.02699 4.81939 7.02699 4.96658V12.2835C7.02699 12.4306 6.90793 12.5497 6.76074 12.5497H6.03356C5.88637 12.5497 5.7673 12.6688 5.7673 12.816V14.2297C5.7673 14.3766 5.88637 14.4956 6.03356 14.4956H8.00012H9.96668C10.1139 14.4956 10.2329 14.3766 10.2329 14.2297V12.816C10.2329 12.6688 10.1139 12.5497 9.96668 12.5497H9.23949C9.0923 12.5497 8.97324 12.4306 8.97324 12.2835V4.96658C8.97324 4.81939 9.0923 4.70033 9.23949 4.70033H10.9023C11.0492 4.70033 11.1686 4.81939 11.1686 4.96658V5.98064C11.1686 6.12783 11.2876 6.24689 11.4345 6.24689H12.8482C12.9954 6.24689 13.1145 6.12783 13.1145 5.98064Z"
      fill="#52525F"
    />
  </svg>
  <svg
    v-else-if="icon === 'interface-common-titles'"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path
        d="M12.6668 8.66672H8.00016C7.63216 8.66672 7.3335 8.36805 7.3335 8.00005C7.3335 7.63204 7.63216 7.33337 8.00016 7.33337H12.6668C13.0348 7.33337 13.3335 7.63204 13.3335 8.00005C13.3335 8.36805 13.0348 8.66672 12.6668 8.66672Z"
        fill="#52525F"
      />
      <path
        d="M15.3335 12H8.00016C7.63216 12 7.3335 11.7013 7.3335 11.3333C7.3335 10.9653 7.63216 10.6666 8.00016 10.6666H15.3335C15.7015 10.6666 16.0002 10.9653 16.0002 11.3333C16.0002 11.7013 15.7015 12 15.3335 12Z"
        fill="#52525F"
      />
      <path
        d="M12.6668 15.3333H8.00016C7.63216 15.3333 7.3335 15.0347 7.3335 14.6667C7.3335 14.2987 7.63216 14 8.00016 14H12.6668C13.0348 14 13.3335 14.2987 13.3335 14.6667C13.3335 15.0347 13.0348 15.3333 12.6668 15.3333Z"
        fill="#52525F"
      />
      <path
        d="M14.8335 1.33337H8.50016C7.85683 1.33337 7.3335 1.85671 7.3335 2.50004V4.16671C7.3335 4.81004 7.85683 5.33337 8.50016 5.33337H14.8335C15.4768 5.33337 16.0002 4.81004 16.0002 4.16671V2.50004C16.0002 1.85671 15.4768 1.33337 14.8335 1.33337Z"
        fill="#52525F"
      />
      <path
        d="M5.84067 2.96667L3.50733 0.800004C3.36133 0.664671 3.14933 0.630004 2.96667 0.708004C2.78467 0.788004 2.66667 0.968004 2.66667 1.16667V2.66667H0.666667C0.298 2.66667 0 2.96534 0 3.33334C0 3.70134 0.298 4 0.666667 4H2.66667V5.5C2.66667 5.69867 2.78467 5.87867 2.96667 5.95867C3.03133 5.986 3.09867 6 3.16667 6C3.29067 6 3.41267 5.954 3.50733 5.86667L5.84067 3.7C5.942 3.60534 6 3.472 6 3.33334C6 3.19467 5.942 3.06134 5.84067 2.96667Z"
        fill="#52525F"
      />
    </g>
  </svg>
  <svg
    v-else-if="icon === 'interface-common-tooltips'"
    width="13"
    height="14"
    viewBox="0 0 13 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.3 0.333374H11.7C12.0448 0.333374 12.3754 0.470338 12.6192 0.714135C12.863 0.957932 13 1.28859 13 1.63337V9.43337C13 9.77816 12.863 10.1088 12.6192 10.3526C12.3754 10.5964 12.0448 10.7334 11.7 10.7334H9.1L6.5 13.3334L3.9 10.7334H1.3C0.955219 10.7334 0.624558 10.5964 0.380761 10.3526C0.136964 10.1088 0 9.77816 0 9.43337V1.63337C0 1.28859 0.136964 0.957932 0.380761 0.714135C0.624558 0.470338 0.955219 0.333374 1.3 0.333374ZM1.95 2.28337V3.58337H11.05V2.28337H1.95ZM1.95 4.88337V6.18337H8.45V4.88337H1.95Z"
      fill="#52525F"
    />
  </svg>
  <svg
    v-else-if="icon === 'interface-common-measure'"
    version="1.1"
    id="Capa_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width="559.497px"
    height="559.496px"
    viewBox="0 0 559.497 559.496"
    xml:space="preserve"
  >
    <g>
      <g>
        <path
          d="M0,514.201h131.076V45.289H0V514.201z M20.026,469.15h27.909v-7.31H20.026v-18.474h27.909v-7.286H20.026v-16.487h27.909
			v-7.299H20.026v-16.383h57.627v-11.701H20.026v-19.967h27.909v-7.299H20.026v-18.461h27.909v-7.287H20.026v-16.5h27.909v-7.298
			H20.026v-16.395h57.627v-11.689H20.026v-23.588h27.909v-7.31H20.026v-18.45h27.909v-7.304H20.026v-16.488h27.909v-7.292H20.026
			v-16.383h57.627v-11.694H20.026v-18.094h35.493v-7.292H20.026v-18.473h35.493v-7.292H20.026v-16.505h35.493v-7.292H20.026V65.315
			h91.012v428.848H20.026V469.15z"
        />
        <path
          d="M166.924,43.543v472.41h392.572L166.924,43.543z M186.968,483.584h27.909v-7.135h-27.909v-18.064h27.909v-7.123h-27.909
			v-16.15h27.909v-7.135h-27.909v-16.021h57.609v-11.42h-57.609v-19.501h27.909v-7.146h-27.909v-18.053h27.909v-7.146h-27.909
			v-16.126h27.909v-7.146h-27.909v-16.009h57.609v-11.42h-57.609v-23.068h27.909v-7.141h-27.909v-18.053h27.909v-7.094h-27.909
			v-16.144h27.909v-7.123h-27.909v-16.039h57.609v-11.391h-57.609v-17.685h35.487v-7.129h-35.487v-18.064h35.487v-7.129h-35.487
			v-43.2L517.413,496.37H186.968V483.584z"
        />
        <path
          d="M256.832,276.151v162.241h134.841L256.832,276.151z M276.87,331.314l72.696,87.473H276.87V331.314z"
        />
      </g>
    </g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
    <g></g>
  </svg>
</template>

<script>
export default {
  name: 'IconsInterfaceCommon',
  props: {
    icon: String,
  },
}
</script>

<style scoped></style>
